import { useAgRequestRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetAddAuthorToGroupRequestCommonInfoQuery } from "../../features/articles/articlesSlice";

export { useAgRequestRoutes };

export default GetDefaultIndex({ title: "درخواست‌های افزودن نویسنده به گروه", query: useGetAddAuthorToGroupRequestCommonInfoQuery });
